import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_97: FaireProductEntity = {
  token: "catalog_prod_prod-97",
  type: "product",
  name: "Figurine",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 90.83,
  msrpDollars: 227.08,
  sku: "CA0097",
  caseSize: 4,
  material: "Wood",
  collectionToken: "col_camp",
  categoryTokens: ["catalog_cat_bath"],
  isNew: false,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 250,
  description: "Beautiful Camp! piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
